import React, { useState } from 'react';
import { FiMenu, FiBell, FiUser } from 'react-icons/fi';

const AdminNavbar = ({ isCollapsed, setIsCollapsed }) => {
  const [userName] = useState('प्रशासक'); // Hardcoded for now as per "Admin" requirement

  const colors = {
    primary: '#085e53',
    text: '#FFFFFF'
  };

  return (
    <div 
      className="h-16 shadow-md flex items-center justify-between px-6 z-40"
      style={{ backgroundColor: colors.primary, color: colors.text }}
    >
      <div className="flex items-center gap-4">
        {/* Mobile Menu Toggle */}
        <button 
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="md:hidden p-2 rounded-full hover:bg-white/10"
        >
          <FiMenu size={24} />
        </button>
        
        <h2 className="text-xl font-semibold hidden md:block">
          ग्राम पंचायत डिजिटल गव्हर्नन्स - प्रशासन कक्ष
        </h2>
        <h2 className="text-lg font-semibold md:hidden">
            प्रशासन कक्ष
        </h2>
      </div>

      <div className="flex items-center gap-6">
        {/* Notification Icon */}
        <button className="relative p-2 rounded-full hover:bg-white/10 transition-colors">
          <FiBell size={20} />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        {/* User Profile */}
        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold">{userName}</p>
            <p className="text-xs opacity-80">मुख्य प्रशासक</p>
          </div>
          <div 
            className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center border-2 border-white/30"
          >
            <FiUser size={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminNavbar;